




















































import { Component, Mixins, Vue } from 'vue-property-decorator';
import { Actions, Mutations } from '@/ts/store/Constants';
import EmptyImage from '@/components/EmptyImage.vue';
import FacilityData from '@/ts/FacilityData';
import FacilityPhotoData from '@/ts/FacilityPhotoData';
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
import StringHelper from '@/mixins/StringHelper.vue';

@Component({
    components: {
        Swiper,
        SwiperSlide,
        EmptyImage,
    },
    directives: {
        swiper: directive,
    },
    data() {
        return {
            swiperOption: {
                pagination: {
                    el: '.swiper-pagination',
                },
            },
        };
    },
})
export default class FacilityDetailsOverlay extends Mixins(StringHelper) {
    constructor() {
        super();
    }

    get facility(): FacilityData {
        return this.$store.getters['SharedFacilities/getUserSelectedFacility'];
    }

    get facilityPhotos(): FacilityPhotoData {
        return this.$store.getters['SharedFacilities/getSharedFacilityPhotos'];
    }

    public showBookOverlay() {
        this.$store.commit(Mutations.SET_BOOK_FACILITY_OVERLAY_VISIBILITY, true);
    }

    public cancel() {
        this.$store.commit(Mutations.SET_FACILITY_DETAILS_OVERLAY_VISIBILITY, false);
    }

    public created() {
        this.$store.dispatch(Actions.FETCH_SHARED_FACILITIES_PHOTOS, this.facility.id);
    }
}
